import classNames from 'classnames';
import { Control, FieldPath, FieldValues } from 'react-hook-form';
import {
  Country,
  getCountries,
  getCountryCallingCode,
} from 'react-phone-number-input';
import PhoneInputWithCountry from 'react-phone-number-input/react-hook-form';
import en from 'react-phone-number-input/locale/en.json';

import { FieldWrapper } from '../FieldWrapper/FieldWrapper';
import styles from './phoneField.module.css';

const labelsWithCallingCode: typeof en = {
  ...en,
  ...Object.fromEntries(
    getCountries().map((code) => [
      code,
      `${en[code]} (+${getCountryCallingCode(code)})`,
    ]),
  ),
};

export interface PhoneFieldProps<T extends FieldValues> {
  control: Control<T>;
  name: FieldPath<T>;
  id?: string;
  label?: string;
  error?: string;
  note?: string | React.ReactNode;
  disabled?: boolean;
  placeholder?: string;
  defaultCountry?: Country;
}

export const PhoneField = <T extends FieldValues>({
  control,
  defaultCountry,
  disabled = false,
  error,
  id,
  label,
  name,
  note,
  placeholder,
}: PhoneFieldProps<T>) => (
  <FieldWrapper
    disabled={disabled}
    error={error}
    id={id}
    label={label}
    note={note}
  >
    <PhoneInputWithCountry
      className={classNames(styles.PhoneField, error && styles.PhoneFieldError)}
      control={control}
      defaultCountry={defaultCountry}
      disabled={disabled}
      id={id}
      international
      labels={labelsWithCallingCode}
      name={name}
      placeholder={placeholder}
    />
  </FieldWrapper>
);
